import all from './all'
import released from './released'
import { combineReducers } from 'redux';

const work_instructions_reducer = combineReducers({
    all,
    released
})

export default work_instructions_reducer;